import { get, sortBy } from 'lodash';
import { ActionHandler } from '../actionHandler';

export interface OptionInterface {
  label: string;
  href: string;
  selected: bool;
  disabled: bool;
  onClick: () => void;
}

export interface MenuGroupInterface {
  title: string;
  options: OptionInterface[];
}

// TODO: add icon, submenu, etc...
function Option({ label, icon, disabled, className: customClasses, ...rest }) {
  const Icon = icon;

  const className = [
    'text-sm',
    'flex',
    'items-center',
    'space-x-1',
    'py-1',
    'px-2',
    '-mx-1',
    'rounded',
    'hover:bg-slate-100',
    customClasses,
    disabled ? 'pointer-events-none opacity-30' : ''
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <span className={className}>
      {icon && <Icon className="w-4 h-4" />}
      <span className="font-hmedium">{label}</span>
    </span>
  );

  if (disabled) {
    return content;
  }

  return <ActionHandler {...rest}>{content}</ActionHandler>;
}

export function Menu({
  groups = [],
  className,
  maxHeight,
  children
}: {
  maxHeight: string;
  options: MenuGroupInterface[];
}) {
  return (
    <div
      className={`divide-y divide-slate-200 ${className} ${maxHeight} overflow-y-scroll relative`}
    >
      {children}
      {groups.map((group, index) => {
        const groupOptions = sortBy(get(group, 'options', []), 'label');

        return (
          <div key={`group-${index}`}>
            {group.title && (
              <div className="px-4 py-1.5 text-sm font-hmedium border-b border-slate-200 bg-slate-50">
                {group.title}
              </div>
            )}
            {groupOptions.length >= 1 && (
              <div className="flex flex-col [&>button]:w-full [&>a]:w-full py-2 p-3">
                {groupOptions.map((opt, index) => (
                  <Option key={index} {...opt} />
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
